import styled from 'styled-components';

export const Container = styled.aside`
  flex: 0 0 46%;
  min-width: 480px;
  min-height: 0;

  label {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    margin-bottom: 0.35rem;
  }

  .update-new-body {
    overflow-y: auto;
  }

  .update-section-title {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .update-dropzone {
    border: 1px dashed ${(props) => props.theme.$primary};
    border-radius: 6px;
    background: ${(props) => props.theme.$primary_light};
    color: ${(props) => props.theme.$primary};
    cursor: pointer;
  }

  .update-dropzone:hover {
    background: ${(props) => props.theme.$primary_medium};
  }

  .update-file {
    font-size: 13px;
  }

  .update-new-footer {
    position: sticky;
    bottom: 0;
    flex-shrink: 0;
    background: ${(props) => props.theme.$white};
  }

  .material-icons {
    font-size: 16px;
  }

  .notes-input-group .material-icons {
    font-size: 24px;
  }
`;
